import { Pipe, PipeTransform } from '@angular/core';
import { TypeStructure } from '../../models/typeStructure';

@Pipe({
	name: 'filterTypeStructureByName'
})
export class FilterTypeStructureByNamePipe implements PipeTransform {
	transform(typeStructure: TypeStructure[], filter: string): TypeStructure[] {
		if (
			!typeStructure ||
			!filter ||
			typeStructure === null ||
			filter === null ||
			filter === ''
		) {
			return typeStructure;
		}

		return typeStructure.filter((typeStructure: TypeStructure) => {
			if (typeStructure.name) {
				// TODO: add lastName too
				return typeStructure.name.toLowerCase().includes(filter.toLowerCase());
			}
			return false;
		});
	}
}
